var H = require("hogan.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b(t.rp("<promopages/blocks/javascript_facebook0",c,p,""));t.b("\n" + i);t.b(t.rp("<promopages/blocks/javascript_twitter1",c,p,""));return t.fl(); },partials: {"<promopages/blocks/javascript_facebook0":{name:"promopages/blocks/javascript_facebook", partials: {}, subs: {  }},"<promopages/blocks/javascript_twitter1":{name:"promopages/blocks/javascript_twitter", partials: {}, subs: {  }}}, subs: {  }}, "{{>promopages/blocks/javascript_facebook}}\n\n{{>promopages/blocks/javascript_twitter}}\n", H);return T; }();


//////////////////
// WEBPACK FOOTER
// ./web/views/promopages/blocks/social_media_scripts.mustache
// module id = 830
// module chunks = 2